import React from 'react'
import { useTranslation } from 'react-i18next';

export  function Terms() {

  const { t } = useTranslation();

  return (
      <>
        <div className="separar"></div>

        <div className="container-fluid contenido text-center reveal">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <h3>{t("pages.terms")}</h3>
              <div className="separar"></div>
            </div>
          </div>
        </div>
        <div className="separar"></div>


        <div className="container faqs reveal">
          <div className="row justify-content-center">
            <div className="col-md-10 letras-chiquitas">
              <p>{t("terms")}</p>
            </div>
          </div>
        </div>

        <div className="separar"></div>
        <div className="separar"></div>
        <div className="separar"></div>
      </>
      
    )
}

export default Terms